<template>

	<div class="landing-terms">
		<section class="container-fluid" v-in-viewport="" >
			<div class="text-center headline-container">  
		  	 	<h1 class="headline" v-in-viewport="">Terms & conditions</h1>
		 	</div>
			<div v-if="terms.length" v-html="terms" class="container block-text">  
		 	</div>
		</section>
	</div>

</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	export default{
		name: 'Terms',
		data () {
		   return {
		   		terms:[]
		   }
		},
		created(){
			this.getTerms();
		},

		mixins:[apiConnection, seoModule]


	}
</script>


// WEBPACK FOOTER //
// Terms.vue?a326629a